import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function ResidencyPassport() {

    return (
        <main className='main'>

            <IntroSection
                title="Residency & Passport Programs"
                subtitle="Expand Your Freedom, Lifestyle, and Opportunities"
                description="Offshore Advisory helps investors, entrepreneurs, and families secure residency and citizenship solutions worldwide. From Europe’s cultural capitals to Asia’s booming economies, we guide you through investment residency programs, second passports, and property-based visas that unlock mobility, tax efficiency, and new markets."
                badges={[
                    "Residency by Investment",
                    "Citizenship Programs",
                    "Investor & Entrepreneur Visas",
                    "Property-Based Residency",
                    "Tax & Lifestyle Optimization"
                ]}
                buttonText="Request a Free Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/residency-passport/residency-passport-hero.png")}
                imageAlt="Residency and Passport Programs"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Benefits of Residency in Another Country'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Global Mobility",
                                        text: "Visa-free or simplified travel to dozens of countries."
                                    },
                                    {
                                        title: "Financial Advantages",
                                        text: "Access to international banking, tax incentives, and global investments."
                                    },
                                    {
                                        title: "Lifestyle & Safety",
                                        text: "Relocate to countries offering better healthcare, education, and stable governance."
                                    },
                                    {
                                        title: "Business Expansion",
                                        text: "Operate cross-border with increased credibility and international presence."
                                    },
                                    {
                                        title: "Family Security",
                                        text: "Include dependents under a single application for long-term stability."
                                    },
                                    {
                                        title: "Path to Citizenship",
                                        text: "Many residency programs provide routes to permanent residency and passports."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency & Citizenship Programs We Offer"
                        blocks={[
                            {
                                title: "Italy: Culture & Lifestyle Residency",
                                items: [
                                    { text: "Elective Residence Visa for retirees and remote-income individuals." },
                                    { text: "Investor Visa for entrepreneurs and high-net-worth applicants." },
                                    { text: "EU residency benefits with a path to long-term residency and citizenship." }
                                ]
                            },
                            {
                                title: "Spain: Golden Visa & Residency",
                                items: [
                                    { text: "€500,000 real estate investment for residency." },
                                    { text: "Full residency rights for spouse and children." },
                                    { text: "Access to EU benefits, healthcare, and education." }
                                ]
                            },
                            {
                                title: "Cyprus: Strategic EU Residency",
                                items: [
                                    { text: "Residency through property or business investment." },
                                    { text: "Attractive tax regime and EU residency rights." },
                                    { text: "Pathway to long-term residency and eventual citizenship." }
                                ]
                            },
                            {
                                title: "Dubai (UAE): Investor Residency",
                                items: [
                                    { text: "Investor visas and retirement residency options." },
                                    { text: "Zero income tax environment." },
                                    { text: "Ideal for entrepreneurs accessing Middle East & global markets." }
                                ]
                            },
                            {
                                title: "Indonesia: PMA Investor Residency (NEW)",
                                items: [
                                    { text: "Residency via establishing a PMA foreign-owned company." },
                                    { text: "Investor KITAS: 2-year renewable residency with work & business rights." },
                                    { text: "Path to permanent residency through long-term presence." },
                                    { text: "Offshore income exemptions when structured correctly." },
                                    { text: "Popular for entrepreneurs relocating to Bali or Jakarta." }
                                ]
                            },
                            {
                                title: "Panama: Gateway to the Americas",
                                items: [
                                    { text: "Friendly Nations Visa: fast permanent residency for eligible nationalities." },
                                    { text: "Pensionado Visa: retiree residency with USD 1,000/month pension." },
                                    { text: "Investment residency options via property, deposits, or business." },
                                    { text: "Citizenship eligibility after 5 years of permanent residency." },
                                    { text: "Dollarized economy, low taxes, and high financial stability." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Extended Services Across Jurisdictions"
                        services={[
                            {
                                title: "Residency Programs",
                                text: "Support for investor visas, golden visas, entrepreneur permits, and long-term residency."
                            },
                            {
                                title: "Property Investment Support",
                                text: "Guidance on real estate and investments that qualify for residency."
                            },
                            {
                                title: "Legal & Financial Assistance",
                                text: "Tax planning, compliance, and legal structuring for immigration strategies."
                            },
                            {
                                title: "Second Passport Advisory",
                                text: "Assistance with citizenship by investment and fast-track passport programs."
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Ready to expand your residency options?"
                        description="From Europe’s Golden Visa to Indonesia’s Investor KITAS, Offshore Advisory makes global residency accessible and secure."
                        buttonText="Book a Residency Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What are the benefits of obtaining a residency visa through investment?",
        content: [
            { type: "answer", text: "Residency by investment grants the right to live, work, and study in the host country, along with tax advantages and a potential path to citizenship." },
        ],
    },
    {
        question: "Can I acquire citizenship through investment?",
        content: [
            { type: "answer", text: "Yes, in select jurisdictions (e.g., St. Lucia, Cyprus, certain Caribbean nations), investment can lead directly to citizenship or eventually to a second passport." },
        ],
    },
    {
        question: "What types of properties qualify for residency?",
        content: [
            { type: "answer", text: "Residential real estate, commercial investments, and government-approved projects typically qualify." },
        ],
    },
    {
        question: "How long does it take to obtain residency or citizenship?",
        content: [
            { type: "answer", text: "Timelines vary: residency is often granted in 2–6 months, while citizenship may require 2–5 years depending on the jurisdiction." },
        ],
    },
    {
        question: "Is Indonesia’s PMA residency suitable for entrepreneurs?",
        content: [
            { type: "answer", text: "Yes — Indonesia’s PMA allows 100% foreign-owned companies in many sectors, granting investors a work permit + residency via Investor KITAS, ideal for digital entrepreneurs, fintech, and hospitality investors." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory guided us step-by-step in obtaining our Cyprus residency. The process was smooth and professional.",
        author: "Elena M.",
        role: "Entrepreneur"
    },
    {
        quote: "Through their PMA setup services, I now live and work in Bali under Investor KITAS. Offshore Advisory handled everything.",
        author: "James L.",
        role: "Tech Founder"
    }
];

